import React from 'react';
import {any, bool, func, oneOf, string} from 'prop-types';
import cx from 'classnames';

import './Button.css';

const SIZE = {
  DEFAULT : 'default',
  LARGE   : 'large',
  SMALL   : 'small'
};

const TYPE = {
  PRIMARY   : 'primary',
  SECONDARY : 'secondary'
};

const propTypes = {
  children  : any,
  className : string,
  disabled  : bool,
  onClick   : func,
  size      : oneOf(Object.values(SIZE)),
  type      : oneOf(Object.values(TYPE))
};

const defaultProps = {
  children  : null,
  className : '',
  disabled  : false,
  onClick   : () => null,
  size      : SIZE.DEFAULT,
  type      : TYPE.PRIMARY
};

function Button (props) {
  const {
    children,
    className,
    disabled,
    onClick,
    size,
    type
  } = props;

  return (
    <button
      className={cx('button', {
        'button--is-disabled' : disabled,
        'button--large'       : size === SIZE.LARGE,
        'button--small'       : size === SIZE.SMALL,
        'button--secondary'   : type === TYPE.SECONDARY
      }, className)}
      disabled={disabled}
      onClick={onClick}
      type="button"
    >
      {children}
    </button>
  );
}

Button.propTypes = propTypes;
Button.defaultProps = defaultProps;
Button.SIZE = SIZE;
Button.TYPE = TYPE;

export default Button;
